export default function SectionLabel({ number, label, testId }) {
  return (
    <div data-testid={testId} className="flex items-center gap-3 mb-6">
      <span className="text-xs uppercase tracking-[0.3em] text-[#F4C75E] font-bold">
        {number}
      </span>
      <span className="w-10 h-px bg-[#F4C75E]" />
      <span className="text-xs uppercase tracking-[0.3em] text-[#A3A3A3]">{label}</span>
    </div>
  );
}
